import React, { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form'
import axios from 'axios'
import {
  Input,
  Loading,
} from '../../common/index'
import message, { Message } from '../../common/Message'

// import { phone_reg, email_reg } from '../../../utils/config'

let timer: any = null

interface Iprops {
  onClose?: (flag: boolean) => void
  location?: string
}

function FormComp(props: Iprops) {
  let [phone, setphone] = useState('')
  let [email, setemail] = useState('')
  let [loading, setloading] = useState(false)

  const {
    onClose,
    location,
  } = props

  const { control, handleSubmit, getValues, clearErrors } = useForm({
    defaultValues: {
      name: '',
      email: "",
      phone: ""
    }
  });

  const checkName = useCallback(() => {
    const {
      email,
      phone,
    } = getValues()
    setphone(phone)
    setemail(email)
    !phone && clearErrors('phone')
    !email && clearErrors('email')
  }, [setphone, setemail, clearErrors, getValues])

  const clearTimer = useCallback(() => {
    timer && window.clearTimeout(timer)
    setloading(false)
  }, [setloading])

  const setTimer = useCallback((time = 3) => {
    timer && clearTimer()
    setloading(true)
    timer = window.setTimeout(() => {
      clearTimer()
    }, time * 1000)
  }, [clearTimer, setloading])

  const onFormSummit = (data: any) => {
    setTimer(8)
    let url = '/chrome_extension/v1/request',
    param = {
      request_info: {
          ...data,
          location
      }
  }
    axios({
      url,
      method: 'post',
      data: param
    })
      .then(originRes => {
        clearTimer()
        if (originRes.data.code === 20201) {
          message('success', 'sucess')
          onClose && onClose(true)
        } else {
          message('submit faild!', 'warning')
        }

      })
      .catch(err => {
        message('submit faild!', 'error')
        clearTimer()
      })
  }

  const onSubmit = handleSubmit(onFormSummit)

  return (
    <div className=' select-none'>
      <Loading
        loading={loading}
      />
      <Message />
      <div className=' font-semibold text-black text-lg text-left'>Sorry we don’t find house close to this area. </div>
      <div className=' text-grey text-2xs text-left mt-[8px]'>Send your request or call us at   <i className=' select-text text-blue not-italic font-semibold'>(949)-288-6628.</i></div>
      <div className=' mt-[24px]'>
        <Input control={control} label="Name" name="name" rules={{ required: 'Please enter name' }} />
        <Input
          className='mt-[20px]' control={control} label="Your email" name="email" 
          rules={{ required: (!phone && !email)  || email ? 'Please enter email' : false, onChange: checkName }} 
        />
      </div>
      <div className=' flex justify-between items-center h-[72px]'>
        <div className=' h-[1px] bg-[#EAEDEE] flex-1' />
        <div className='h-[24px] w-[53.7px] text-base text-grey text-center'>OR</div>
        <div className=' h-[1px] bg-[#EAEDEE] flex-1' />
      </div>
      <div>
        <Input control={control} label="Phone" name="phone" rules={{ required: (!phone && !email) || phone ? 'Please enter phone' : false, onChange: checkName }} />
      </div>
      <button
        onClick={() => onSubmit()}
        className=' w-[100%] mt-[24px] h-[52px] bg-blue cursor-pointer select-none rounded-[8px] text-base text-white flex justify-center items-center'
      >
        submit
      </button>
    </div>
  );
}

export default FormComp;
